// Meter photo slots for Monthly Inspection Reports.
//
// Historically a fixed four (image_5..image_8: Gas Meter 1, Gas Meter 2,
// Electric Meter, Water Meter). Extended to a pool of ten (image_5..image_14)
// so properties with several electricity meters (e.g. "Hollington Youth Club",
// which has five) can capture every reading. The first four keep their standard
// default names; extra slots start unnamed.
//
// Shared by MonthlyInspectionCreate and MonthlyInspectionEdit so the slot pool
// and default names stay in sync.

export const METER_PHOTO_POOL = [
  "image_5",
  "image_6",
  "image_7",
  "image_8",
  "image_9",
  "image_10",
  "image_11",
  "image_12",
  "image_13",
  "image_14",
];

export const METER_DEFAULT_NAMES = {
  image_5: "Gas Meter 1",
  image_6: "Gas Meter 2",
  image_7: "Electric Meter",
  image_8: "Water Meter",
};

// The standard four slots shown before any are added / loaded.
export const DEFAULT_METER_SLOTS = METER_PHOTO_POOL.slice(0, 4);
